import {useScroll, useElementBounding, watchThrottled} from '@vueuse/core';
import {HEADER_STICKY_SCROLL_RATIO} from '#shared/constants';

export function useStickyHeader(headerRef: Ref<HTMLElement | null>, isDesktop: Ref<boolean>) {
	const isSticky = ref(false);
	const lastScrollY = ref(0);
	const {y: scrollY, directions} = useScroll(window, {behavior: 'smooth'});
	const {height: headerHeight} = useElementBounding(headerRef);
	const minScrollThreshold = computed(() => headerHeight.value * HEADER_STICKY_SCROLL_RATIO);

	watchThrottled(
		[scrollY, () => directions.top, () => directions.bottom, minScrollThreshold, isDesktop],
		() => {
			if (!isDesktop.value) {
				isSticky.value = false;
				lastScrollY.value = scrollY.value;
				return;
			}

			if (scrollY.value <= minScrollThreshold.value) {
				isSticky.value = false;
				lastScrollY.value = scrollY.value;
				return;
			}

			const scrollDelta = Math.abs(scrollY.value - lastScrollY.value);

			if (scrollDelta >= minScrollThreshold.value) {
				if (directions.top) {
					isSticky.value = false;
				} else if (directions.bottom) {
					isSticky.value = true;
				}
				lastScrollY.value = scrollY.value;
			}
		},
		{throttle: 100, leading: true, trailing: true},
	);

	return {isSticky};
}
